import React from "react";
import { Link, navigate } from 'gatsby';
import { FormattedMessage } from 'react-intl'
import { SectionNav
        ,MoveNavigation
        ,ShowingPage
        ,SelectPage
       } from '../theme/globalStyle'

const PAGE_SIZE = 10;

class Navigation extends React.Component {

    changePage = e => {
        //navigate(e.target.value ? `/blog/page/${e.target.value}` : ``)
        navigate(e.target.value)
        //navigateTo(e.target.value ? `/blog/page/${e.target.value}` : `/blog/`)
    }

    render(){

        const PAGES = Math.ceil(this.props.totalCount / PAGE_SIZE);
        const pageContext = this.props.pageContext;

        return(
            <SectionNav>
                <MoveNavigation> 
                    <li>
                        {pageContext && 
                            pageContext.hasPreviousPage && (
                                <Link to={pageContext.previousPageLink}> &larr; <FormattedMessage id="previous-page" /></Link>
                            )
                        }

                        {pageContext != null && 
                            pageContext.hasPreviousPage === false && (
                                <span>&larr; <FormattedMessage id="previous-page" /></span>
                            )
                        }
                    </li>
                    <li>
                        {pageContext && 
                            pageContext.hasNextPage && (
                                <Link to={pageContext.nextPageLink}><FormattedMessage id="next-page" /> &rarr; </Link>
                            )
                        }

                        {pageContext != null && 
                            pageContext.hasNextPage === false && (
                                <span><FormattedMessage id="next-page" /> &rarr; </span>
                            )
                        }
                    </li>
                </MoveNavigation>
                
                <ShowingPage> 
                    <li><FormattedMessage id="showing-the-page" />: </li>
                    <li>
                        <SelectPage onChange={this.changePage} value={pageContext.pageNumber === 1 ? `${pageContext.contextPageLink}` : `${pageContext.contextPageLink}${pageContext.pageNumber.toString()}`}>
                            {Array.from({ length: PAGES }, (_, i) => (
                                <option
                                    value={`${pageContext.contextPageLink}${i===0 ? `` : (i + 1)}`}
                                    key={`pagination-number${i + 1}`}
                                >
                                    {i + 1}
                                </option>
                            ))}
                        </SelectPage>
                    </li>
                    <li>
                        <FormattedMessage id="of" /> <strong>{PAGES}</strong>
                    </li>
                </ShowingPage>
            </SectionNav>
        )
    };
}

export default Navigation;